import { ActionBase } from '../../../core/store/action/ActionBase';
import { ExtractPageViewModel } from "../../models/ExtractPageViewModel";

export const GENERATE_EXTRACT = '[Extract] Generate Extract';

export class GenerateExtractAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = GENERATE_EXTRACT;

  constructor(public payload: { model: ExtractPageViewModel }) {}
}



// WEBPACK FOOTER //
// ./src/app/extracts/store/actions/GenerateExtractAction.ts